const Modal = function () {
  return {
    hide: null,
    show: null,
  }
}

export default Modal
